import type { IconData } from '@stacksjs/iconify-core'

export const ellipsisV: IconData = {
  "body": "<circle cx=\"12\" cy=\"12\" r=\"2\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"5\" r=\"2\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"19\" r=\"2\" fill=\"currentColor\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default ellipsisV
